import { PropsWithChildren, ReactNode, useState } from "react";
import { useTranslation } from '@fanfanlo';
import styles from './components.module.scss';
import { Tooltip } from "@mui/material";
import { ClickAwayListener } from "@mui/material";
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
export function PermissionCommonSetting(){
    const {t} = useTranslation('homepage/components/permissions/components/content');
    return <span className={styles.permissionComponentsSpanPadding}>
        <button data-testid="PermissionCommonSetting__settingButton__01JG2B0077" data-test-comment="权限设置通用按钮，点击后打开对应权限的系统设置">
        <span>{t('Components.setting')}</span>
    </button>
    </span>
}

export function PermissionCommonNotPass(){
    const {t} = useTranslation('homepage/components/permissions/components/content');
    return <>
        <span className={styles.permissionComponentsSpanPadding}>{t('Components.notPass')}</span>
    </>
}

export function PermissionCommonPass(){
    const {t} = useTranslation('homepage/components/permissions/components/content');
    return <>
        <span className={styles.permissionComponentsSpanPadding}>{t('Components.pass')}</span>
    </>
}


export function PermissionCommonDanger({desc}:{desc:ReactNode}&PropsWithChildren){
    const {t} = useTranslation('homepage/components/permissions/components/content');
    
  const [openTooltip, setOpenTooltip] = useState(false);
    return(
        <span className={styles.danger}>
        <ClickAwayListener onClickAway={() => setOpenTooltip(false)}>
          <Tooltip
            disableFocusListener
            disableHoverListener
            disableTouchListener
            title={desc}
            slotProps={{
              popper: {
                disablePortal: true,
              },
            }}
            open={openTooltip}
            onOpen={() => setOpenTooltip(true)}
            onClose={() => setOpenTooltip(false)}>
            <span onMouseDown={() => setOpenTooltip(true)}>
              
        <span>{t('Components.danger')}</span>
              <span></span>
              <span>
                <QuestionMarkIcon fontSize="small" sx={{ verticalAlign: 'sub' }} />
              </span>
            </span>
          </Tooltip>
        </ClickAwayListener>
        </span>
    )
}

export function PermissionCommonName({children}:PropsWithChildren){
    return (
        <span>{children}</span>
    )
}

export function PermissionCommonDesc({children}:PropsWithChildren){
    return (
        <span>{children}</span>
    )
}

